import getPriceBillingConfig from './getPriceBillingConfig';

function checkHasBillingCycleAnchorConfig(price) {
  if (!price) return false;
  const config = getPriceBillingConfig(price);
  if (
    config?.billingCycleAnchorConfig?.enabled &&
    (config.interval === 'year' || config.interval === 'month')
  ) {
    return true;
  }

  return false;
}

export { checkHasBillingCycleAnchorConfig };
